// contexts/ChatContext.jsx
import React, { createContext, useState, useContext } from 'react';

const ChatContext = createContext();

export const ChatProvider = ({ children, workspaceData, initialChatMessages = [], onSuggestionsReceived }) => {
    const [chatMessages, setChatMessages] = useState(initialChatMessages);
    
    return (
        <ChatContext.Provider value={{
            chatMessages,
            setChatMessages,
            workspaceData
        }}>
            {children}
        </ChatContext.Provider>
    );
}

export const useChat = () => useContext(ChatContext);